import App from "../App/App.js";
import config from "./_config.json";
var apiEndpoint = App.Env.Api + config.dashboard;

export default {
  getReport(params) {
    const attributes = ["startdate", "enddate", "warehouse"];
    const urlParams = App.Out.getParams(params, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/report" + urlParams
    };
  },
  getReportData(params) {
    const attributes = ["startdate", "enddate", "warehouse"];
    const urlParams = App.Out.getParams(params, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/reportdata" + urlParams
    };
  }
}